import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import GaziantepLanding from "./components/GaziantepLanding";
import GocekLanding from "./components/GocekLanding";
import CenevreLanding from "./components/CenevreLanding";
import CenevreLandingEn from "./components/CenevreLandingEn";
import AboutPage from "./components/AboutPage";
import CommunityPage from "./components/CommunityPage";
import MembershipPage from "./components/MembershipPage";
import ApplyPage from "./components/ApplyPage";
import PitchDeck from "./components/PitchDeck";
import BirthdayInvite from "./components/BirthdayInvite";
import LegalPage from "./components/LegalPage";
import favicon from "./img/gws-app-icon.png";

const Home = () => {
  return (
    <div className="relative">
      <Navbar textColor="white" logoVariant="white" showCenterLogo={false} />
      <HeroSection overlayVariant="none" textColor="white" />
    </div>
  );
};

function App() {
  useEffect(() => {
    // Doğum günü davetiyesi GWS markası taşımaz; favicon'unu kendisi yönetir
    if (window.location.pathname === '/birthday-invitation') return;
    const link = document.querySelector("link[rel~='icon']");
    if (!link) {
      const newLink = document.createElement('link');
      newLink.rel = 'icon';
      newLink.href = favicon;
      document.head.appendChild(newLink);
    } else {
      link.href = favicon;
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/experience" element={<CommunityPage />} />
          <Route path="/membership" element={<MembershipPage />} />
          <Route path="/apply" element={<ApplyPage />} />
          <Route path="/zeugmadan-sofraya-gaziantep" element={<GaziantepLanding />} />
          <Route path="/port-azure-gocek-yat-hafta-sonu" element={<GocekLanding />} />
          <Route path="/koleksiyonerin-ruyasi-cenevre-2026" element={<CenevreLanding />} />
          <Route path="/collectors-dream-geneva-2026" element={<CenevreLandingEn />} />
          <Route path="/gws-pitch-deck" element={<PitchDeck />} />
          <Route path="/birthday-invitation" element={<BirthdayInvite />} />
          <Route path="/app-privacy-policy" element={<LegalPage type="privacy" />} />
          <Route path="/app-terms" element={<LegalPage type="terms" />} />
          {/* Mağaza listeleri gws.karmanbeyond.com/privacy ve /app-privacy-policy'ye işaret ediyor; domain buraya yönleniyor */}
          <Route path="/privacy" element={<LegalPage type="privacy" />} />
          <Route path="/privacy-policy" element={<LegalPage type="privacy" />} />
          <Route path="/terms" element={<LegalPage type="terms" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
